import { defineComponent as _defineComponent } from 'vue'
import { getProductsCatalog } from '@/api/storesApp/printful';
import ProductSelector from '../ProductSelector/ProductSelector.vue';
import type { File, FileWithSize, ProductClass } from '@/typings/printful/product';
import type { GenericPodProduct } from '../ProductSelector/typings';
import type { PodProviderConfiguration, TemplateProductConfiguration } from '../typings';
import { Ref, onBeforeMount, ref } from 'vue';
import VariantsConfigurator from '@/components/TemplateProductPodAssigner/VariantsConfigurator/VariantsConfigurator.vue';
import RevisionStep from '@/components/TemplateProductPodAssigner/RevisionStep/RevisionStep.vue';
import { Placeholder } from '../VariantsConfigurator/typings';
import { SelectedProviderVariants } from '@/typings/printify/printProvider';


export default /*#__PURE__*/_defineComponent({
  __name: 'PrintfulConfigurator',
  props: {
    store: null,
    initialConfiguration: null
  },
  emits: ['save'],
  setup(__props: any, { emit }) {

const props = __props as {
    store: string;
    initialConfiguration: TemplateProductConfiguration;
};





const showUnassignConfirmModal = ref(true);
const productToUnassign: Ref<GenericPodProduct | null> = ref(null);
const selectedProviderVariants: Ref<SelectedProviderVariants[]> = ref([]);
const printfulProducts: Ref<ProductClass[]> = ref([]);
const selectedProducts: Ref<GenericPodProduct[]> = ref([]);
const products: Ref<GenericPodProduct[]> = ref([]);
const step: Ref<'selectProduct' | 'selectFile' | 'finalRevision'> = ref('selectProduct');

const selectedProduct: Ref<GenericPodProduct | null> = ref(null);
let biggestPlaceholders: FileWithSize[] = [];
let printfulFiles: Ref<File[] | undefined> = ref([]);

const templateProductConfiguration: TemplateProductConfiguration = props.initialConfiguration;

onBeforeMount(() => {
    templateProductConfiguration.configurations = templateProductConfiguration.configurations.filter(
        (c) => c.provider === 'printful'
    );
    loadProducts();
});

const loadProducts = async () => {
    printfulProducts.value = await getProductsCatalog(props.store);
    products.value = printfulProducts.value.map((p) => ({
        id: p.id.toString(),
        title: p.title || p.model,
        image: p.image,
        description: p.description
    }));

    const ids = templateProductConfiguration.configurations.map((c) => c.productId);
    selectedProducts.value = products.value.filter((p) => ids.includes(p.id));
};

const onProductSelected = async (product: GenericPodProduct) => {
    selectedProduct.value = product;
    printfulFiles.value = printfulProducts.value.find((p) => p.id.toString() === product.id)?.files;

    if (!printfulFiles.value) {
        throw Error(`No files found for Printful product ${product.id}`);
    }
    step.value = 'selectFile';
};

const onProductUnassignClick = (product: GenericPodProduct) => {
    productToUnassign.value = product;
    showUnassignConfirmModal.value = true;
};

const unassignProduct = (product: GenericPodProduct | null) => {
    if (product) {
        // Remove any POD configuration belonging to the unassigned product
        templateProductConfiguration.configurations = templateProductConfiguration.configurations.filter(
            (c) => c.productId !== product.id
        );
        onSave();
    }
};

const onVariantsSelected = (value: {
    configurations: PodProviderConfiguration[];
    biggestPlaceholders: Placeholder[];
    selectedProviderVariants: SelectedProviderVariants[];
}) => {
    step.value = 'finalRevision';
    templateProductConfiguration.configurations = value.configurations;
    selectedProviderVariants.value = value.selectedProviderVariants;
    biggestPlaceholders = value.biggestPlaceholders.map(
        (pl): FileWithSize => ({
            file: pl.file!,
            width: pl.width,
            height: pl.height,
            dpi: pl.dpi ?? 300,
            aspectRatio: pl.aspectRatio ?? '',
            variantIds: []
        })
    );
};

const onSave = async () => {
    if (!selectedProduct.value || !biggestPlaceholders.length) {
        throw new Error('No product selected and trying to save configuration');
    }

    emit('save', {
        configuration: templateProductConfiguration,
        biggestPlaceholders: biggestPlaceholders.map((x) => {
            return {
                id: x.file.type,
                width: x.width,
                height: x.height,
                dpi: x.dpi,
                aspectRatio: x.aspectRatio
            };
        })
    });
};

return { __sfc: true,props, emit, showUnassignConfirmModal, productToUnassign, selectedProviderVariants, printfulProducts, selectedProducts, products, step, selectedProduct, biggestPlaceholders, printfulFiles, templateProductConfiguration, loadProducts, onProductSelected, onProductUnassignClick, unassignProduct, onVariantsSelected, onSave, ProductSelector, VariantsConfigurator, RevisionStep }
}

})